import type { FspFileItem, FspFileObj } from "Api/beFsp";
import type {
  ImportFilesConfigRequest,
  ImportFilesPreviewResponse,
} from "Types/beRecipientsApi";

export enum WizardSteps {
  UploadFile = "UploadFile",
  Preview = "Preview",
  DynimicFields = "DynimicFields",
  GroupsAndSettings = "GroupsAndSettings",
  CopyPaste = "CopyPaste",
}

export interface UploaderState {
  variant: string;
  hintDanger: string;
  file: UploaderObj | undefined;
  fileName: string;
  filePath: string;
}

export interface UploaderObj {
  name: any;
  size: any;
  fileObj: any | undefined;
  fileExt: any;
}

export interface TableState {
  loading: boolean;
  items: FspFileItem[];
  totalItems: number;
  orderBy: string;
  orderDescending: boolean;
  pageNumber: number;
  pageSize: number;
  fileSelected: string;
  fileSelectedExt: string;
}

export interface ModalDelesteFileImportState {
  show: boolean;
  fileName: string;
}

export interface ImportFileWizardState extends ImportFilesConfigRequest {
  FileName: string;
  FileExt: string;
}

export type PreviewTableStateType = ImportFilesPreviewResponse & {
  loading: boolean;
};

export interface DynamicFieldsOptionType {
  label: string;
  value: number;
}

export interface RecipientGroupsState {
  loading: boolean;
  status: "initial" | "ready" | "error";
  items: GroupInfo[];
  totalItems: number;
  pageNumber: number;
  pageSize: number;
  orderBy: "IdGroup" | "GroupName" | "AssignmentDate";
  orderDescending: boolean;
}

export interface GroupInfo {
  Id: number;
  Name: string;
  AssignmentDate: string;
}

export interface ModalNewGroup {
  Show: boolean;
  GroupName: string;
  IsDirty: boolean;
}

export interface OptionsMessagesConfirmation {
  options: SelectOption[];
}

export interface SelectOption {
  label: string;
  value: number;
}

export const TABLE_FILES_EXTRA_COLUMN_BEFORE_WIDTH = "15px";
export const TABLE_FILES_EXTRA_COLUMN_AFTER_WIDTH = "26px";
